export default "__VITE_ASSET__Cjm3Hf0Q__"